<template>
  <div
    class="site-collapse-item"
    :class="{'is-active': isActive, 'is-disabled': disabled }"
    :style="itemBgStyle"
  >
    <div
      role="tab"
      :aria-expanded="isActive"
      :aria-controls="`site-collapse-content-${id}`"
      :aria-describedby="`site-collapse-content-${id}`"
      @click.capture="handleHeaderClick"
    >
      <div
        :id="`site-collapse-head-${id}`"
        role="button"
        :tabindex="disabled ? undefined : 0"
        :class="['site-collapse-item__header', {'focusing': focusing,'is-active': isActive}]"
        :style="itemBgStyle"
        @focus="handleFocus"
        @blur="focusing = false"
      >
        <slot name="title">{{title}}</slot>
        <i
          class="site-collapse-item__arrow el-icon-arrow-right"
          :style="{color: (arrowColor ? arrowColor: '')}"
          :class="{'is-active': isActive}"
        ></i>
      </div>
    </div>
    <SiteCollapseTransition>
      <div
        v-show="isActive"
        :id="`site-collapse-content-${id}`"
        class="site-collapse-item__wrap"
        role="tabpanel"
        :aria-hidden="!isActive"
        :aria-labelledby="`site-collapse-head-${id}`"
      >
        <div class="site-collapse-item__content">
          <slot></slot>
        </div>
      </div>
    </SiteCollapseTransition>
  </div>
</template>
<script>

import SiteCollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import Emitter from '../mixins/emitter';
const generateId = function () {
  return Math.floor(Math.random() * 10000);
};
export default {
  name: 'SiteCollapseItem',

  componentName: 'SiteCollapseItem',

  components: { SiteCollapseTransition },

  mixins: [Emitter],

  inject: ['collapse'],

  props: {
    title: String,
    name: {
      type: [String, Number],
      default() {
        return this._uid;
      }
    },
    disabled: Boolean,
    arrowColor: {
      type: String,
      default: ''
    },
    itemBgStyle: {
      type: Object,
      default: () => { }
    }
  },

  data() {
    return {
      contentWrapStyle: {
        height: 'auto',
        display: 'block'
      },
      contentHeight: 0,
      focusing: false,
      isClick: false,
      id: generateId()
    };
  },

  computed: {
    isActive() {
      return this.collapse.activeNames.includes(this.name);
    }
  },

  methods: {
    handleFocus() {
      setTimeout(() => {
        if (!this.isClick) {
          this.focusing = true;
        } else {
          this.isClick = false;
        }
      }, 50);
    },
    handleHeaderClick() {
      if (this.disabled) return;
      this.dispatch('SiteCollapse', 'item-click', this);
      this.focusing = false;
      this.isClick = true;
    },
    handleEnterClick() {
      this.dispatch('SiteCollapse', 'item-click', this);
    }
  }
};
</script>
